'use es6';

import I18n from 'I18n';
import { useSelector } from 'react-redux';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsPublicContent, getIsUsingPersonalization } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncLayoutStylesSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'LayoutStylesSidebarContainer' */'ContentEditorUI/containers/layoutStyles/LayoutStylesSidebarContainer'));
const AsyncEditModuleSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'EditModuleSidebarContainer', webpackPrefetch: true */'ContentEditorUI/containers/EditModuleSidebarContainer'));
const AsyncTreeViewModuleListContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'TreeViewModuleListContainer' */'ContentEditorUI/components/sidebar/list/treeView/TreeViewModuleListContainer'));
const AsyncPageDesignSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PageDesignSidebarContainer' */'page-editor-ui/containers/PageDesignSidebarContainer'));
const PageSidebarPanelContainer = ({
  panelName,
  selectedRowOrColumn,
  selectedModuleInTree,
  selectedModuleName,
  editSidebarActiveTab,
  selectedField
}) => {
  const hasTheme = useSelector(getHasTheme);
  const contentId = useSelector(getContentModelId);
  const isPublicContent = useSelector(getIsPublicContent);
  const isUsingPersonalization = useSelector(getIsUsingPersonalization);
  if (!panelName) {
    return null;
  } else if (panelName === SIDEBAR_PANELS.addWidget) {
    // Add sidebar panel has an iframe an is handled elsewhere
    return null;
  } else if (panelName === SIDEBAR_PANELS.preview) {
    // Preview modal is handled elsewhere (but it still a "sidebar panel" in the code from pre-Baymax logic)
    return null;
  } else if (panelName === SIDEBAR_PANELS.widgetList) {
    return /*#__PURE__*/_jsx(AsyncTreeViewModuleListContainer, {
      allowBodyStyling: true
    });
  } else if (panelName === SIDEBAR_PANELS.edit) {
    // If this is a D&D area thing
    if (selectedRowOrColumn) {
      // And the thing is a row or column, but not a module
      if (selectedRowOrColumn.isRow() || selectedRowOrColumn.isCell() && !selectedRowOrColumn.isModule()) {
        return /*#__PURE__*/_jsx(AsyncLayoutStylesSidebarContainer, {
          showDeviceToggle: true,
          node: selectedRowOrColumn
        });
      }
    }
    return /*#__PURE__*/_jsx(AsyncEditModuleSidebarContainer, {
      contentId: contentId,
      isPublicContent: isPublicContent,
      showDeviceToggle: true,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField,
      isSmartContentEnabledForApp: !isUsingPersonalization,
      smartContentDisabledForAppReason: I18n.text('sidebar.edit.smartContentDisabledForAppReason')
    });
  } else if (panelName === SIDEBAR_PANELS.design) {
    return hasTheme ? /*#__PURE__*/_jsx(AsyncPageDesignSidebarContainer, {}) : /*#__PURE__*/_jsx(AsyncEditModuleSidebarContainer, {
      isBodyStyle: true,
      showDeviceToggle: true,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField,
      isSmartContentEnabledForApp: !isUsingPersonalization,
      smartContentDisabledForAppReason: I18n.text('sidebar.edit.smartContentDisabledForAppReason')
    });
  }
  throw new Error(`Unknown panel: ${panelName}`);
};
export default PageSidebarPanelContainer;